const warningModalEquipService = {
  titleInactivate: 'Desabilitar serviço',
  textInactivate: 'Ao desabilitar este serviço, ele deixará de ser utilizado neste tipo de equipamento, não contará no cálculo de status e perderá seus serviços agendados, mas seu histórico será mantido.',
  text2Inactivate: 'Deseja prosseguir?',
  confirmButtonTextInactivate: 'DESABILITAR SERVIÇO',
  titleActivate: 'Habilitar Serviço',
  textActivate: 'Ao ativar este serviço, ele será utilizado para este tipo de equipamento e contará no cálculo de status.',
  text2Activate: 'Deseja continuar?',
  confirmButtonTextActivate: 'HABILITAR SERVIÇO',

};

export default warningModalEquipService;
